import { useMemo } from 'react';
import type { MilestonesStore } from '.';

export function useActiveMilestones(store: MilestonesStore) {
  return useMemo(
    () => store.state.list.filter((item) => !item.data.deleted_at),
    [store.state.list],
  );
}

export function useUpcomingMilestones(store: MilestonesStore) {
  const dt = new Date();
  dt.setMinutes(0, 0, 0);
  const now = dt.toISOString();

  return useMemo(() => {
    return store.state.list.filter((item) => item.data.next_occurrence >= now);
  }, [now, store.state.list]);
}
